var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row preview-container", style: _vm.cssBackgroundVars },
    [
      _vm.configurations.templateType === _vm.configType.onlyText
        ? _c("div", { staticClass: "col-6 preview-text-1" }, [
            _vm._v(" " + _vm._s(_vm.renderData()) + " ")
          ])
        : _vm._e(),
      _vm.configurations.templateType === _vm.configType.desing
        ? _c("div", { staticClass: "col-6 sign-container sign-design" }, [
            _c("div", { staticClass: "signature-font" }, [
              _vm._v(" " + _vm._s(_vm.configurations.emulation) + " ")
            ])
          ])
        : _vm._e(),
      _vm.configurations.templateType === _vm.configType.draw
        ? _c("div", { staticClass: "col-6 sign-container" }, [
            _c("img", {
              staticClass: "sign-image",
              attrs: { src: _vm.signatureImage }
            })
          ])
        : _vm._e(),
      _vm.configurations.templateType === _vm.configType.atached
        ? _c("div", { staticClass: "col-6 sign-container" }, [
            _c("img", {
              staticClass: "sign-image",
              attrs: { src: _vm.signatureImage }
            })
          ])
        : _vm._e(),
      _vm.configurations.templateType !== _vm.configType.onlyText
        ? _c("div", { staticClass: "col-6 preview-text-2" }, [
            _vm._v(" " + _vm._s(_vm.renderData()) + " ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }